'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Vegetable Serve information
 */
var GrainServe = function (_Component) {
  (0, _inherits3.default)(GrainServe, _Component);

  function GrainServe() {
    (0, _classCallCheck3.default)(this, GrainServe);
    return (0, _possibleConstructorReturn3.default)(this, (GrainServe.__proto__ || (0, _getPrototypeOf2.default)(GrainServe)).apply(this, arguments));
  }

  (0, _createClass3.default)(GrainServe, [{
    key: 'render',
    value: function render() {
      var grainServe = require('../Assets/grainserve.png');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'strong',
          null,
          'One serve is equivalent to:'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            ReactBootstrap.Col,
            { md: 6 },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1 slice (40g) bread'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1/2 medium roll or flat bread'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1/2 cup cooked rice, pasta, noodles, barley or quinoa'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1/2 cup cooked porridge'
              )
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Col,
            { md: 6 },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '2/3 cup wheat cereal flakes'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1/4 cup muesli'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '3 crispbreads'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1 crumpet'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1 small English muffin'
              )
            )
          )
        ),
        _react2.default.createElement(ReactBootstrap.Image, { src: grainServe, responsive: true, className: 'center-block' })
      );
    }
  }]);
  return GrainServe;
}(_react.Component);

exports.default = GrainServe;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ServeInformation/GrainServe/GrainServe.js
// module id = 1266
// module chunks = 0